<style>
  .search-table-outter { overflow-x: scroll; }
  
  </style>
<div class="col-md-12">
  <h3 class="">Report - Opex Accrual</h3>
  <hr style="margin: 0;border: lightgray solid 0.5px; ">
<br />
<div class="panel panel-primary">
    <div class="panel-heading">Search Information</div>
    <div class="panel-body">
  <form name="form" (ngSubmit)="f.form.valid && search()" #f="ngForm"  novalidate>
    <div class="form">
        
      <div class="form-group row">
        <label for="SupplierNamelbl" class="col-sm-2 col-form-label">Supplier Name:</label>
        <div class="col-sm-4">
          <input placeholder="All" name="SupplierNamelbl" id="SupplierNamelbl" type="text" class="form-control" [(ngModel)]="SupplierAB" [ngbTypeahead]="searchSupplier"/>
          
  </div>
     
        <label for="ObjectAccountlbl" class="col-sm-2 col-form-label">Object Account:</label>
        <div class="col-sm-4">
          <input placeholder="All" name="ObjectAccountlbl" id="ObjectAccountlbl" type="text" class="form-control" [(ngModel)]="ObjectAccount" [ngbTypeahead]="searchObjectAcnt"/>
        </div>
      </div>
      <div class="form-group row"> 
        <label for="Arealbl1" class="col-sm-2 col-form-label">Area:</label>
        <div class="col-sm-4">
         
          <input placeholder="All" name="Arealbl1" id="Arealbl1" type="text" class="form-control" [(ngModel)]="Area" [ngbTypeahead]="searchArea"/>
        </div>
      
        <label for="Departmentlbl1" class="col-sm-2 col-form-label">Department:</label>
        <div class="col-sm-4">
         
          <input placeholder="All" name="Departmentlbl1" id="Departmentlbl1" type="text" class="form-control" [(ngModel)]="Department" [ngbTypeahead]="searchDepartment"/>
        </div>
      </div> 
        <div class="form-group row">
          <label for="Yearlbl" class="col-sm-2 col-form-label">Year:</label>
          <div class="col-sm-4">
              
              <select id="Yearlbl" class="form-control" [(ngModel)]="Year" name ="Yearlbl" #Yearlbl="ngModel" [ngClass]="{ 'is-invalid': f.submitted && Yearlbl.invalid }" required>
                  <option value="" selected>Select</option>    
                <option *ngFor="let _yrs of getYrs" [ngValue]="_yrs" >{{_yrs}}</option>
                </select>
                <div *ngIf="f.submitted && Yearlbl.invalid" class="invalid-feedback invalid-display">
                    <div *ngIf="Yearlbl.errors?.['required']">Year is required</div>
                </div>
          </div>
        </div>    
        <div class="form-group row">
          <label for="dpAppr" class="col-sm-2 col-form-label">Compliance Approved Date:</label>
             <div class="col-sm-3">
              <input class="form-control" 
              name="dpAppr" id="dpAppr" [(ngModel)]="ApprDt" ngbDatepicker #dt="ngbDatepicker" #dpAppr="ngModel" [disabled]="user.Role!='Admin'" [disabled]="user.Role!='ReadOnly'" [ngClass]="{ 'is-invalid': f.submitted && dpAppr.invalid }" required> 
              <div *ngIf="f.submitted && dpAppr.invalid" class="invalid-feedback invalid-display">
                <div *ngIf="dpAppr.errors?.['required']">*Approved date is required</div>
              </div>
            </div>
             <div class="col-sm-1" style="padding-left: 0px;">
                <button class="glyphicon glyphicon-calendar" (click)="dt.toggle()" type="button" [disabled]="user.Role!='Admin'"[disabled]="user.Role!='ReadOnly'"></button>
             </div>
             
      </div>    
      <div class="form-group row">
        <div class="col-sm-2 col-form-label"></div>
        <div class="col-sm-4">
          <button class="btn btn-primary"  >Search</button>
        </div>
      </div>
    </div>
  </form>
    <div class="clearfix"></div>
  </div>
  </div>
  
<br /> <br />
<div class="search-table-outter" *ngIf="OpexAccrualResult.length > 0">
  <table class="table table-bordered" >
    <thead>
      <tr>
          <th scope="col" >Supplier</th>
          <th scope="col" >Values(Total Sum)</th>
          <th scope="col" >Jan</th>
          <th scope="col" >Feb</th>
          <th scope="col" >Mar</th>
          <th scope="col" >Apr</th>
          <th scope="col" >May</th>
          <th scope="col" >Jun</th>
          <th scope="col" >Jul</th>
          <th scope="col" >Aug</th>
          <th scope="col" >Sep</th>
          <th scope="col" >Oct</th>
          <th scope="col" >Nov</th>
          <th scope="col" >Dec</th>
          <th>Total</th>
      </tr>
    </thead>
    <tbody *ngIf="OpexAccrualResult != null || OpexAccrualResult != undefined"> 
      <tr *ngFor="let accrual of OpexAccrualResult | paginate: config">
          <td>{{accrual.SupplierName}}</td>
          <td>{{accrual.Property1}}</td>
          <td>{{accrual.Jan| currency}}</td>
          <td>{{accrual.Feb| currency}}</td>
          <td>{{accrual.Mar| currency}}</td>
          <td>{{accrual.Apr| currency}}</td>
          <td>{{accrual.May| currency}}</td>
          <td>{{accrual.Jun| currency}}</td>
          <td>{{accrual.Jul| currency}}</td>
          <td>{{accrual.Aug| currency}}</td>
          <td>{{accrual.Sep| currency}}</td>
          <td>{{accrual.Oct| currency}}</td>
          <td>{{accrual.Nov| currency}}</td>
          <td>{{accrual.Dec| currency}}</td>
          <td>{{accrual.Total| currency}}</td>
      </tr>
    </tbody>
  </table>
  <pagination-controls *ngIf="OpexAccrualResult" (pageChange)="pageChanged($event)"></pagination-controls>
</div>
<br>
<div class="form-group row" *ngIf="OpexAccrualResult.length > 0">
     <div class="col-sm-4">  
        <button (click)="ExportTOExcel()" class="btn btn-primary">ExportTOExcel</button>
      </div> 
</div> 
<table class="table table-bordered hidden"  id="reportGrid_all">
  <thead>
    <tr>
        <th scope="col" >Supplier</th>
        <th scope="col" >Values(Total Sum)</th>
        <th scope="col" >Jan</th>
        <th scope="col" >Feb</th>
        <th scope="col" >Mar</th>
        <th scope="col" >Apr</th>
        <th scope="col" >May</th>
        <th scope="col" >Jun</th>
        <th scope="col" >Jul</th>
        <th scope="col" >Aug</th>
        <th scope="col" >Sep</th>
        <th scope="col" >Oct</th>
        <th scope="col" >Nov</th>
        <th scope="col" >Dec</th>
        <th>Total</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let accrual of OpexAccrualResult ">
        <td>{{accrual.SupplierName}}</td>
        <td>{{accrual.Property1}}</td>
        <td>{{accrual.Jan| currency}}</td>
        <td>{{accrual.Feb| currency}}</td>
        <td>{{accrual.Mar| currency}}</td>
        <td>{{accrual.Apr| currency}}</td>
        <td>{{accrual.May| currency}}</td>
        <td>{{accrual.Jun| currency}}</td>
        <td>{{accrual.Jul| currency}}</td>
        <td>{{accrual.Aug| currency}}</td>
        <td>{{accrual.Sep| currency}}</td>
        <td>{{accrual.Oct| currency}}</td>
        <td>{{accrual.Nov| currency}}</td>
        <td>{{accrual.Dec| currency}}</td>
        <td>{{accrual.Total| currency}}</td>
    </tr>
  </tbody>
</table>